// Following constants represent pixel values for DataGrid columns

export const MIN_COLUMN_WIDTH = 20
export const MAX_COLUMN_WIDTH = 200

export const DEFAULT_LABEL_COLUMN_WIDTH = 100
export const MIN_LABEL_COLUMN_WIDTH = 60

export const DEFAULT_PADDING = 24
export const DROPDOWN_PADDING_ADJUSTMENT = 70

export const DEFAULT_FONT = "12px Open Sans"
export const GROUP_HEADER_FONT = `700 ${DEFAULT_FONT}`
export const METRIC_HEADER_FONT = "600 10.5px Open Sans"

export const MIN_EXPANDED_COLUMN_WIDTH = 96
export const BUFFER_WIDTH = 1
export const EXTERNAL_ICON_WIDTH = 20

export const COMPACT_GRID_MAX_WIDTH = 600
export const HEADER_MAX_LINES = 3
export const COMPACT_HEADER_MAX_LINES = 2
export const HEADER_LINE_HEIGHT = 15
export const HEADER_VERTICAL_PADDING = 6
export const HEADER_CELL_PADDING = 4
export const HEADER_ICON_SLOT_WIDTH = 20
export const HEADER_RESERVED_WIDTH = HEADER_CELL_PADDING * 2 + HEADER_ICON_SLOT_WIDTH * 2
export const HEADER_FIT_WIDTH_SLACK = 2
export const HEADER_MIN_TEXT_WIDTH = 42
export const DEFAULT_METRIC_COLUMN_WIDTH = HEADER_RESERVED_WIDTH + HEADER_MIN_TEXT_WIDTH
export const GO_TO_FINDER_HEADER_CLASS = "has-go-to-finder"
export const MIN_LEAF_HEADER_HEIGHT = 39
export const STACKED_ICONS_HEADER_HEIGHT = 44
export const GROUP_HEADER_BASE_HEIGHT = 56
export const DEFAULT_COLUMN_TYPE_WIDTH = 100

export const SPACING_UNIT_PX = 8
export const GO_TO_FINDER_GUTTER = 5 // theme.spacing(5) === 40px, room for the finder icon
export const GO_TO_FINDER_WIDTH = GO_TO_FINDER_GUTTER * SPACING_UNIT_PX
export const GO_TO_FINDER_MIN_WIDTH = 220
export const GO_TO_ROW_FLASH_DURATION_MS = 1600
